// Really just a component, but exists as a top-level route.
import DmmLoginCallback from 'app/components/auth/DMMLoginCallback';
export default DmmLoginCallback;
